module.exports = ".modal-text {\n  font-size: 1.4em;\n  line-height: 1.3em; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/brands/modals/gdpr-disable-modal/gdpr-disable-modal.scss
// module id = ./web/modern/components/brands/modals/gdpr-disable-modal/gdpr-disable-modal.scss
// module chunks = 0